export default __webpack_public_path__ + "static/media/longCloud12.4a9637be.webp";